export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Car Loan EMI Calculator: Drive Your Dream Car with Smart Planning",
    subHeading:
      "Buying a car is an exciting milestone, but understanding and managing your car loan EMI is crucial to ensuring a stress-free financial journey. With Minemi’s Car Loan EMI Calculator, you can plan your monthly payments, compare loan options, and make informed decisions that suit your budget.",

    notice:
      "With Minemi’s Car Loan EMI Calculator, you can confidently plan your loan, compare lenders, and save money. Start calculating today and take the first step toward driving your dream car!",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
